import React from 'react';

const Footer = () => {
    return (
        <footer style={{
            position: 'fixed',
            bottom: 0,
            width: '100%',
            backgroundColor: '#f8f9fa',
            padding: '20px 0',
            textAlign: 'center',
            borderTop: '1px solid #eee',
            zIndex: 1000
        }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 15px' }}>
                <p style={{ margin: 0, color: '#666' }}>
                    &copy; {new Date().getFullYear()}  WeShop All rights reserved.
                </p>
            </div>
        </footer>
    );
};

export default Footer;
